module.exports = __webpack_public_path__ + "img/back2.b5e437ee.png";